import * as actionTypes from '../actions/actionTypes';

const DEFAULT_STATE = {
    openModal: null,
};

const navigationReducer = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE': {
            return DEFAULT_STATE;
        }
        case actionTypes.OPEN_MODAL: {
            return {
                ...state,
                openModal: action.payload,
            };
        }
        case actionTypes.CLOSE_MODAL: {
            return {
                ...state,
                openModal: null,
            };
        }
        default: {
            return state;
        }
    }
};

export default navigationReducer;



// WEBPACK FOOTER //
// /src/redux/reducers/navigationReducer.js